import { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import { Button, Col, Modal, Row } from "antd";
import { LeftArrowIcon } from "assets/images";
import { setChangeOpenningTimeModal } from "providers/GeneralProvider/slice";
import i18n from "i18n";
import CustomOpenningTime from "./CustomOpenningTime";
import "./styles.less";

const initWorkingTime = [
  {
    key: 0,
    label: "Thứ hai:",
    time: [
      {
        shift: 0,
      },
    ],
  },
  {
    key: 1,
    label: "Thứ ba:",
    time: [
      {
        shift: 0,
      },
    ],
  },
  {
    key: 2,
    label: "Thứ tư:",
    time: [
      {
        shift: 0,
      },
    ],
  },
  {
    key: 3,
    label: "Thứ năm:",
    time: [
      {
        shift: 0,
      },
    ],
  },
  {
    key: 4,
    label: "Thứ sáu:",
    time: [
      {
        shift: 0,
      },
    ],
  },
  {
    key: 5,
    label: "Thứ bảy:",
    time: [
      {
        shift: 0,
      },
    ],
  },
  {
    key: 6,
    label: "Chủ nhật:",
    time: [
      {
        shift: 0,
      },
    ],
  },
];

const ChangeOpenningTimeModal = ({
  openningTimeModal,
  handleChangeOpenningTime,
  fieldAlwaysOpen = "alwaysOpen",
  fieldAlwaysClose = "alwaysClose",
  title = i18n.t("menu.settingPromotionTime"),
  canDisableSelectTimeSlot = false,
}) => {
  const { isOpen, data, category } = openningTimeModal;
  const dispatch = useDispatch();
  const modalProps = _get(openningTimeModal, "data", {});
  const { okButtonProps, onOk, onCancel, ...props } = modalProps;
  const { openningTimeData = [] } = data;
  const formattedOpenningTimeData = openningTimeData.map((item, index) => {
    const key = index;
    let label = "";
    let time = [];
    if (
      item?.time?.length > 0 &&
      item?.time?.[0]?.from &&
      item?.time?.[0]?.to &&
      !item?.[fieldAlwaysOpen] &&
      !item?.[fieldAlwaysClose]
    ) {
      time = item?.time;
    } else if (
      !item?.[fieldAlwaysOpen] &&
      !item?.[fieldAlwaysClose] &&
      item?.time?.length === 0
    ) {
      time = [
        {
          shift: 0,
        },
      ];
    }
    if (key === 0) {
      label = "Thứ hai:";
    } else if (key === 1) {
      label = "Thứ ba:";
    } else if (key === 2) {
      label = "Thứ tư:";
    } else if (key === 3) {
      label = "Thứ năm:";
    } else if (key === 4) {
      label = "Thứ sáu:";
    } else if (key === 5) {
      label = "Thứ bảy:";
    } else if (key === 6) {
      label = "Chủ nhật:";
    }
    return {
      ...item,
      time,
      label,
      key,
    };
  });

  const [workingTimeOfWeek, setWorkingTimeOfWeek] = useState(
    _isEmpty(openningTimeData) ? initWorkingTime : formattedOpenningTimeData
  );

  const disabledConfirm = workingTimeOfWeek.some((day) => {
    if (day?.[fieldAlwaysOpen] || day?.[fieldAlwaysClose]) {
      return false;
    }
    if (day?.time?.length > 0) {
      return !day?.time?.every((dayItem) => dayItem?.from && dayItem?.to);
    }

    return true;
  });

  const handleCancel = () => {
    if (typeof onCancel === "function") {
      onCancel();
    }
    dispatch(
      setChangeOpenningTimeModal({
        isOpen: false,
        data: {},
        category,
      })
    );
  };

  const handleConfirmWorkingTime = () => {
    handleChangeOpenningTime({
      openningTimeData: workingTimeOfWeek,
    });
    handleCancel();
  };

  const handleSelectOption = (option) => {
    const newWorkingTime = [];
    if (option === "time_custom") {
      initWorkingTime?.forEach((item) => {
        newWorkingTime.push({
          ...item,
        });
      });
    }
    if (option === "always_open") {
      initWorkingTime?.forEach((item) => {
        newWorkingTime.push({
          ...item,
          [fieldAlwaysOpen]: true,
        });
      });
    }
    if (option === "always_close") {
      initWorkingTime?.forEach((item) => {
        newWorkingTime.push({
          ...item,
          [fieldAlwaysClose]: true,
        });
      });
    }
    setWorkingTimeOfWeek(newWorkingTime);
  };

  const handleTimeCustomChange = (workingTimeOfWeekUpdated) => {
    setWorkingTimeOfWeek(workingTimeOfWeekUpdated);
  };

  return (
    <Modal
      visible={isOpen}
      afterClose={() =>
        dispatch(
          setChangeOpenningTimeModal({
            data: {},
            isOpen: false,
            category,
          })
        )
      }
      style={{ zIndex: 9999 }}
      footer={null}
      closable={false}
      centered
      className="change-working-time-popup-wrapper"
      {...props}
    >
      <div className="change-working-time-popup-container">
        <div className="change-working-time-popup-header">
          <div className="header-title-container">
            <img
              onClick={handleCancel}
              className="icon-close"
              src={LeftArrowIcon}
              alt=""
            />
            <div className="header-content">{title}</div>
          </div>
          <Button
            onClick={handleConfirmWorkingTime}
            size="small"
            className="confirm-btn"
            type="primary"
            disabled={disabledConfirm}
          >
            {i18n.t("loginScreen.verifyOtp")}
          </Button>
        </div>
        <Row className="change-working-time-popup-body">
          <Col span={24} className="create-custom-working-time-container">
            <CustomOpenningTime
              workingTimeOfWeek={workingTimeOfWeek}
              setWorkingTimeOfWeek={setWorkingTimeOfWeek}
              onSelectOption={handleSelectOption}
              onTimeCustomChange={handleTimeCustomChange}
              fieldAlwaysOpen={fieldAlwaysOpen}
              fieldAlwaysClose={fieldAlwaysClose}
              canDisableSelectTimeSlot={canDisableSelectTimeSlot}
            />
          </Col>
        </Row>
      </div>
    </Modal>
  );
};
ChangeOpenningTimeModal.propTypes = {
  openningTimeModal: PropTypes.object,
  handleChangeOpenningTime: PropTypes.func,
  title: PropTypes.string,
  fieldAlwaysOpen: PropTypes.string,
  fieldAlwaysClose: PropTypes.string,
};

export default ChangeOpenningTimeModal;
